import { render, staticRenderFns } from "./adminPayFeeDetailList.vue?vue&type=template&id=53030a13&scoped=true"
import script from "./adminPayFeeDetailList.vue?vue&type=script&lang=js"
export * from "./adminPayFeeDetailList.vue?vue&type=script&lang=js"
import style0 from "./adminPayFeeDetailList.vue?vue&type=style&index=0&id=53030a13&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53030a13",
  null
  
)

export default component.exports